import React, { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("artha_token");
    if (!t) {
      setLoading(false);
      return;
    }
    authApi.me()
      .then((u) => setUser(u))
      .catch(() => localStorage.removeItem("artha_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await authApi.login({ email, password });
    localStorage.setItem("artha_token", token);
    setUser(user);
    return user;
  };

  const signup = async (data) => {
    const { token, user } = await authApi.signup(data);
    localStorage.setItem("artha_token", token);
    setUser(user);
    return user;
  };

  const startDemo = async () => {
    const res = await authApi.startDemo();
    localStorage.setItem("artha_token", res.token);
    setUser(res.user);
    return res;
  };

  const logout = () => {
    localStorage.removeItem("artha_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, startDemo, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
